const cashflow = {
  methods: {
    getCat (item) {
      let category = '',
          options = this.get_global.defaults.options.financial.cashflow || {}
      if (item.type < 2) {
        category = options.types[item.type - 1]
      } else {
        let cat = options.categories.find(cat => cat.id === item.category)
        category = cat || {}
      }
      return category
    },
    getType (type) {
      let options = this.get_global.defaults.options.financial.cashflow.types || []
      return options[type - 1] || ''
    },
    getMethod (method) {
      let options = this.get_global.defaults.options.financial.cashflow.methods || []
      return options[method - 1] || ''
    },

    save_ () {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 5, data: { subpage: 1, ...this.selected }, item: this.id })
      }
    },
    delete_ (item) {
      this.$store.dispatch('setOverlay', true)
      this.$dialog.confirm({
        text: this.lang.financial.cashflow.dialog.delete(item.title),
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) {
          this.$store.dispatch('saveMixed', { page: 5, type: 1, data: { subpage: 1, ...item }, ignoreResponseBar: false })
        }
      })
    }
  }
}
export default cashflow
